'use strict';


import { Report } from './QAReport';
import { Buildings, settingsData } from '../../settings';

export class QAKeyPlan extends Report{
	constructor () {
		super('KeyPlan');
	}
	
	validate() {
		if (this.jsonReport.length) {
			this.showReport();
			return;
		}
		
		new Promise(resolve => {
			const interval = setInterval(() => {
				if (typeof settingsData.commonAssets === 'object') {
					clearInterval(interval);
					resolve(settingsData.commonAssets);
				}
			},200);
		}).then((assets) => {
			if (Object.keys(assets).length === 0) {
				this.addError(null,`Common assets is absent`);
				this.normalize();
				this.showReport();
				return;
			}
			
			const buildings = Buildings.getBuildingsArray();
			buildings.forEach(building => {
				const amenities = assets[building.name]?.floorAmenities;
				if (amenities) {
					building.floorSliderNumbers.forEach(floorNum => {
						const data = amenities.find(floor => floorNum >= Number(floor.from) && floorNum <= Number(floor.to));
						if (!data || (data && !data.assets.plan2D)) {
							this.addError(null,`Building: ${building.info.labelName}, Floor: ${floorNum}. Message: KeyPlan is absent`);
						}
					});
				} else {
					this.addError(null,`Building: ${building.info.labelName}, Message: Floor amenities is absent`);
				}
			});
			
			this.normalize();
			this.showReport();
		})
		
	}
	
	normalize () {
		if (!this.log.length) {
			this.jsonReport.push('OK');
		} else {
			this.log.forEach(errorData => this.jsonReport.push(errorData.message));
		}
	}
	
}
